module.exports = __webpack_public_path__ + "images/8a0c5d6c3fc22ebd9a4950ffdebfed7b.png";